import React from 'react'
import {getCSRFToken} from 'js/utils/csrf_token'

const CSRF = (): JSX.Element => {
  return <input name="_csrf_token" type="hidden" value={getCSRFToken()} />
}

export default CSRF
